import wixCodeMonitoring from './wixCodeMonitoringWrapper'
import hooks from '../../hooks/hooks'
import type {PS} from '@wix/document-services-types'
import {HttpClient} from '@wix/http-client'
import {provisionApp} from '@wix/ambassador-velo-apps-v1-app/http'
import _ from 'lodash'
import experiment from 'experiment-amd'
import clientSpecMap from '../../siteMetadata/clientSpecMap'
import constants from '../utils/constants'

function _updateWixCodeModel(ps: PS, gridAppId: string) {
    ps.extensionAPI.wixCode.setOpenWixCodeAppId(gridAppId)
    hooks.executeHook(hooks.HOOKS.AUTOSAVE.ACTION, null, [ps])
    return
}
function getWixCodeApp(ps: PS) {
    if (experiment.isOpen('dm_cloudSiteExtensionMigrationDev')) {
        const wixCodeApp = clientSpecMap.getAppDataByAppDefinitionId(ps, constants.WIX_CODE_APP_DEF_ID)
        return wixCodeApp ?? _.head(clientSpecMap.filterAppsDataByType(ps, constants.WIX_CODE_SPEC_TYPE))
    }
    return _.head(clientSpecMap.filterAppsDataByType(ps, constants.WIX_CODE_SPEC_TYPE))
}
async function _doProvision(ps: PS) {
    const {editorRootUrl} = ps.dal.get(ps.pointers.general.getServiceTopology())

    const wixHttpClientInstance = new HttpClient({
        baseURL: editorRootUrl,
        getAppToken: ps.extensionAPI.siteAPI.getInstance
    })
    try {
        const res = await wixHttpClientInstance.request(provisionApp({}))
        const gridAppId = _.get(res, 'data.app.id', '')
        _updateWixCodeModel(ps, gridAppId)
        return
    } catch (error: any) {
        throw error.response.data
    }
}

async function provision(ps: PS) {
    const traceEnd = wixCodeMonitoring.trace(ps, {action: 'createApp'})
    const existingWixCodeApp = getWixCodeApp(ps)

    if (isProvisioned(ps)) {
        traceEnd({message: 'wix code is already provisioned'})
        return existingWixCodeApp
    }

    try {
        await _doProvision(ps)
        await ps.extensionAPI.rendererModel.refreshClientSpecMap()
        traceEnd()
        return getWixCodeApp(ps)
    } catch (error) {
        traceEnd({message: error, level: wixCodeMonitoring.levels.ERROR})
        throw error
    }
}

const isProvisioned = (ps: PS) => ps.extensionAPI.wixCode.isProvisioned()

export default {
    provision,
    isProvisioned
}
